import React from "react";
// import parse from 'html-react-parser';
const CompanyContainer = ({ companies }) => (
  <>
    {companies.map((company, idx) => (
      <a href={company.link} className="company-list__item" key={idx}>
        <p className="logo">
          {company._embedded &&
            company._embedded["wp:featuredmedia"] &&
            company._embedded["wp:featuredmedia"][0] &&
            company._embedded["wp:featuredmedia"][0].media_details.sizes &&
            company._embedded["wp:featuredmedia"][0].media_details.sizes.company ? (
              <img
                src={
                  company._embedded["wp:featuredmedia"][0].media_details.sizes
                    .company
                    ? company._embedded["wp:featuredmedia"][0].media_details
                        .sizes.company.source_url
                    : company._embedded["wp:featuredmedia"][0].media_details
                        .sizes.full.source_url
                }
                alt={company.title.rendered}
              />
            ) : (
            <img
                src={
                    (company._embedded["wp:featuredmedia"] &&
                    company._embedded["wp:featuredmedia"][0] &&
                    company._embedded["wp:featuredmedia"][0].source_url) ? 
                    company._embedded["wp:featuredmedia"][0].source_url :
                    "https://upload.wikimedia.org/wikipedia/en/thumb/9/98/Blank_button.svg/1200px-Blank_button.svg.png"
                }
                width="0"
                height="0"
                alt={company.title.rendered}
              />
            )}
        </p>
        <p className="company-category">{company.title.rendered}</p>
      </a>
    ))}
  </>
);

export default CompanyContainer;
